import ConduitEvents from '@tagboard/lib-events';

let instance;

const ConduitEventsService = {
  async init(userId) {
    instance = await ConduitEvents.initialize({
      pusherKey: process.env.PUSHER_KEY,
      pusherCluster: process.env.PUSHER_CLUSTER,
      pusherAuthApi: process.env.CONDUIT_PUSHER_AUTH_API,
      userId,
      eventLogging: (process.env.NODE_ENV || '').toLowerCase() !== 'production',
    });

    return instance;
  },

  /**
   * @param {string} eventName - Format: `{source}.{action/category}.{eventName}` Example: 'producer.action.sportradar-element-added' or 'producer.event.production-went-live'
   * @param {object} eventData - The event data payload
   * @param {object} [eventContext] - Additional event context data
   * @returns {*}
   */
  track: (eventName, eventData, eventContext) => instance?.track(eventName, eventData, eventContext),
};

export default ConduitEventsService;
